import React, { Component } from 'react';

import RegisterComponent from '../components/registerEmployee';

export default class RegisterEmployee extends Component {
    render() { 
        const {...props} = this.props
        return (
            <div className='login-root'>
                <div className='bg-login'>
                    <div className='img-inside'></div>
                </div>
                <RegisterComponent {...props} />
            </div>
        )
    }

}

